import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import SearchTours from './components/SearchTours';
import PopularDestinations from './components/PopularDestinations';
import HotTours from './components/HotTours';

import AboutUs from './components/AboutUs';
import MobileAppPromo from './components/MobileAppPromo';
import Testimonials from './components/Testimonials';
import ContactInfo from './components/ContactInfo';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <div className="min-h-screen bg-neutral-50">
      <Header />
      <main>
        <Hero />
        <SearchTours />
        <PopularDestinations />
        <HotTours />

        <AboutUs />
        <MobileAppPromo />
        <Testimonials />
        <ContactInfo />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
